/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { type App } from '~/app';


export default (app: App) => {    
    app.logger.debug('[Stockland FE] Initialise Stockland MPC Progress timeline Component');

    const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => {
            setTimeout(() =>{
                mountProgressTimeLine(listeners)
            }, 300)
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Feature Links and Image component', error);
        });

    return function destroyFreeTextQuickLinks() {
        unMountProgressTimeLine(listeners)

        app.logger.debug('[DXA] Feature Links and Image component destroyed');
    };


    function mountProgressTimeLine(
        listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>,
        root: HTMLElement | null = null) {

        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            if (entry.isIntersecting){
                observer.unobserve(entry.target);

                const value = document.getElementById(entry.target.id);
                          
                const child = value?.children[0] as HTMLElement;
                if (child !== undefined || child !== null){
                    const childWidth = child?.style.width;
                    document.documentElement.style.setProperty(`--progressValue`,`${childWidth}`);
                    child.animate(
                        [
                            ///keyframes
                            {width: "0%"},
                            {width:`${childWidth}` }
                        ],
                        {
                            duration: 4000,
                            iterations: 1
                        }
                    );
                }
            }
        });
              
        // Tell the observer which elements to track
        const elements =document.querySelectorAll(".mpc-progress-bar")
        for (const element of elements){
            observer.observe(element);
        }
        
    }


    function unMountProgressTimeLine(
        listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>
    ) {
        for (const [element, event, listener] of listeners) {
            element.removeEventListener(event, listener);
        }
    }
}